// 过滤简历申请状态
const hrPermissionStateList = {
  'applied':'待通过',
  'rejected':'已拒绝',
  'passed':'已通过',
}
const hrPermissionState = value => {
	if (!value) return ''
  return hrPermissionStateList[value]
}
export { hrPermissionState }